import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_CONDITION_HEATMAP_ACTION_TYPE } from '../actions/conditionHeatmap.actions';

const initialState = null;

const conditionHeatmapReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_CONDITION_HEATMAP_ACTION_TYPE.SET_CONDITION_HEATMAP:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default conditionHeatmapReducer;
